"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Theme = require("../../../Theme/Theme.variables");

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Gt726 =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Gt726, _PureComponent);

  function Gt726() {
    _classCallCheck(this, Gt726);

    return _possibleConstructorReturn(this, _getPrototypeOf(Gt726).apply(this, arguments));
  }

  _createClass(Gt726, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          height = _this$props.height,
          width = _this$props.width,
          style = _this$props.style,
          className = _this$props.className;
      var color = (0, _Theme.variables)(this.props)[this.props.color];
      return _react.default.createElement(_IconBase.IconBase, _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        style: style,
        className: className,
        viewBox: "0 0 75.166504 96"
      }, this.props), _react.default.createElement("title", null, "Generation Tux GT 726 Logo"), _react.default.createElement("path", {
        fill: color,
        d: "M20.84 93.77h-1.78c3.33-2.788 4.798-4.258 4.798-6.07 0-1.713-1.367-2.82-3.483-2.82-1.778 0-3.118 1.14-3.118 2.652 0 1.13.743 1.92 1.807 1.92.653 0 1.198-.442 1.198-1.192 0 0-.126.127-.55.127-.623 0-.996-.435-.996-1.165 0-1.05.65-1.73 1.66-1.73 1.428 0 1.728 1.217 1.728 2.237 0 1.702-.8 3.278-5.178 7.17l-.063.085v.27h6.797l.458-2.853c-.728 1.218-1.657 1.367-3.278 1.367zM5.525 84.99l-.233-.103-.32 3.024c.568-.943 1.184-1.296 2.378-1.296h3.315l-.31.437c-1.8 2.525-3.067 4.87-3.402 8.105l-.023.227 1.903-.178v-.17c0-2.83.342-5.09 2.04-7.63l1.356-2.02v-.273H6.462c-.326 0-.692-.015-.938-.125zm28.98 3.79c-1.11 0-1.994.458-2.518 1.28 0-2.096.69-4.54 2.63-4.54.862 0 1.42.467 1.42 1.193 0 .334-.16.672-.518.672-.19 0-.38-.035-.484-.098 0 .798.63 1.12 1.13 1.12.762 0 1.315-.595 1.315-1.414 0-1.226-1.204-2.117-2.863-2.117-2.532 0-4.3 2.243-4.3 5.455 0 2.438 1.205 5.06 3.85 5.06 2.01 0 3.47-1.422 3.47-3.383 0-2.384-1.688-3.23-3.132-3.23zm-.296 5.945c-1.79 0-1.928-2.068-1.928-2.7 0-1.522.724-2.505 1.842-2.505 1.51 0 1.828 1.362 1.828 2.504 0 .812-.17 2.7-1.743 2.7zm40.105-16.49c-1.382 7.976-5 12.338-10.212 12.338-4.786 0-7.34-3.51-7.34-10.426V46.002h16.063l.532-2.766H56.763V26.325h-1.368C53.26 38.693 44.802 45.344 28.91 45.344c-2.73 0-8.188.008-10.918.01-5.43.002-8.304-1.492-8.304-5.11 0-2.983 2.98-5.11 5.75-6.07 2.874 1.172 6.174 1.81 10.22 1.81 13.414 0 20.76-7.77 20.76-17.353 0-3.513-.96-6.813-2.982-9.58 1.17-1.49 3.194-3.408 5.643-3.408 2.447 0 3.83 1.384 3.83 3.407 0 1.81-.53 2.874-1.915 3.83v.214c3.94 0 8.73-1.703 8.73-7.026 0-3.726-2.45-6.068-6.92-6.068-4.898 0-7.985 4.896-10.007 8.198-3.62-4.366-9.582-6.92-17.14-6.92-13.308 0-20.654 7.77-20.654 17.352 0 5.963 3.088 11.604 8.942 14.8C8.73 34.812 3.62 38.324 3.62 43.65c0 6.493 5.642 9.686 11.604 10.325C6.174 55.04 0 59.085 0 65.475 0 75.16 13.734 79.1 25.23 79.1c8.787 0 16.713-2.153 22.172-5.993v7.36c0 10.32 5.212 15.533 13.51 15.533 9.573 0 13.403-7.552 14.255-17.764h-.852zM25.657 3.086c7.346 0 10.86 7.133 10.86 15.543s-3.514 15.543-10.86 15.543c-7.24 0-10.752-7.133-10.752-15.543S18.418 3.087 25.657 3.087zm-.532 73.99c-9.475 0-16.608-4.684-16.608-12.243 0-7.24 5.11-10.752 13.627-10.752h11.71c8.41 0 12.883 2.98 12.883 10.113 0 7.77-8.198 12.883-21.612 12.883z"
      }));
    }
  }]);

  return Gt726;
}(_react.PureComponent);

Gt726.displayName = 'Gt726'; // Prop Types

Gt726.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  color: _propTypes.default.string.isRequired
};
Gt726.defaultProps = {
  className: '',
  style: {},
  width: '75.167',
  height: '96',
  color: '#ccc'
};

var _default = (0, _styledComponents.withTheme)(Gt726);

exports.default = _default;